import { gql } from "@apollo/client";

export const GET_PAST_PETS = gql`
query getRetiredPets{
    getRetiredPets {
        locationId
        success
        messages
        pets {
            id
            name
            image
            breedName
            birthdate
            retiredOn
            isWellnessplan
        }
    }
}
`;
